import React, { useRef, useState } from 'react';
import { SearchItem } from '../../../types';
import PreviewPopover from './PreviewPopover';

interface Props {
	item: SearchItem;
	className: string;
	dataId: string;
	dataSrc?: string;
	children: React.ReactNode;
	extensions?: string[];
}

export function Item({ item, className, dataId, dataSrc, children, extensions }: Props) {
	const [isActive, setIsActive] = useState(false);
	const ref = useRef<HTMLLIElement>(null);

	const handleMouseEnter = () => {
		setIsActive(true);
	};

	const handleMouseLeave = () => {
		setIsActive(false);
	};

	const itemClassName = `${className} ${isActive ? 'active' : ''}`;

	return (
		<>
			<li
				className={itemClassName}
				data-id={dataId}
				data-id-hash={item.idHash}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				data-src={dataSrc}
				ref={ref}
				style={{ position: 'relative' }}
			>
				{children}
			</li>
			<PreviewPopover imageSrc={dataSrc || ''} imageExtensions={extensions || []} ref={ref} />
		</>
	);
}
